import "./FxeWelcomeWizardComponent.scss";
import template from "./FxeWelcomeWizardComponent.html";
import {IComponentOptions, IHttpService, IOnDestroy, IScope, IWindowService} from "angular";
import LegalsJson from "../../legal/legal.json";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {Observable, ReplaySubject} from "rxjs";
import {LegalDocument, Legals, Section} from "../../legal/types/LegalDocument";
import {CurrentUser} from "../../../services/user/models/CurrentUser";
import {UserService} from "../../../services/user/UserService";
import {ThemingStore} from "../../../theming/store/ThemingStore";
import {IModalInstanceService} from "angular-ui-bootstrap";

export const FxeWelcomeWizard = "tfFxeWelcomeWizard";

export function fxeWelcomeWizard(): IComponentOptions {
    return {
        template,
        bindings: {
            modalInstance: "<"
        },
        controllerAs: "ctrl",
        controller: FxeWelcomeWizardComponent
    };
}

export class FxeWelcomeWizardComponent implements IOnDestroy {

    /** @input */
    public readonly modalInstance: IModalInstanceService;

    public readonly title$: Observable<string>;
    public readonly legalIntro$: Observable<ReadonlyArray<string>>;
    public readonly legalSections$: Observable<ReadonlyArray<Section>>;

    public currentStepNumber = 1;
    public givenName: string | null = null;
    public surname: string | null = null;
    public phone: string | null = null;

    private readonly legalDocs: LegalDocument = LegalsJson;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService,
                       private readonly userService: UserService,
                       private readonly themingStore: ThemingStore,
                       private readonly $scope: IScope,
                       private readonly $http: IHttpService,
                       private readonly $window: IWindowService) {
        const content$ = this.buildLegalContent();
        this.title$ = content$.map((c) => c.title);
        this.legalIntro$ = content$.map((c) => c.introParagraphs).map((p) => p.map(this.htmlify));
        this.legalSections$ = content$.map((c) => c.sections)
                                      .map((sections) => {
                                          sections.forEach((s: any) => s.content = this.htmlify(s.content));
                                          return sections;
                                      });

        this.currentUserService
            .current
            .first()
            .subscribe((user) => this.setUpFormData(user));
    }

    private buildLegalContent(): Observable<Legals> {
        return this.currentUserService
                   .current
                   .map((user) => user.broker)
                   .distinctUntilChanged()
                   .map((broker) => this.legalDocs[broker] || LegalsJson.TF)
                   .publishReplay(1)
                   .refCount();
    }

    private htmlify(value: string) {
        const bold = /“(.*?)”/g;
        const italic = /‘(.*?)’/g;
        return value.replace(bold, "<b>“$1”</b>").replace(italic, "<i>‘$1’</i>");
    }

    private setUpFormData(user: CurrentUser) {
        if (user.profile.givenName != null) {
            this.givenName = user.profile.givenName;
            this.surname = user.profile.surname;
        } else {
            const fullName = user.shortName;
            const split = fullName.split(" ");
            const givenName = split[0];
            const surnameIndex = Math.max(1, split.length - 1);
            const surname = split[surnameIndex];
            this.givenName = givenName;
            this.surname = surname;
        }
    }

    public nextPage() {
        this.currentStepNumber = this.currentStepNumber + 1;
    }

    public previousPage() {
        this.currentStepNumber = this.currentStepNumber - 1;
    }

    public updatePhone(value: string | null) {
        this.phone = value;
        this.userService.updateContactNumber(this.phone);
    }

    public submitPersonal() {
        this.updatePhone(this.phone!);
        this.userService.updateFullName(this.givenName!, this.surname!);
        this.acceptTerms();
    }

    public acceptTerms() {
        this.$http.put("/tradefloor/api/user/legal/terms", null);
        this.$http.put("/tradefloor/api/user/onboard", null);
        this.modalInstance.close();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}